document.addEventListener("DOMContentLoaded", () => {
    const state = {
        uploadedImage: null,
        shape: "Die-cut (WITH BORDER)",
        size: '20" Inches',
        Lamination: "No",
        Notes: "",
        price: 9.99,
    };

    const FREE_SHIP_THRESHOLD = 25;
    const MOST_POPULAR_SIZE = '20" Inches';
    const BEST_VALUE_SHAPE = "Die-cut (NO BACKGROUND)";

    const ALLOWED_UPLOAD_EXT = [
        "jpg", "jpeg", "png", "svg", "pdf", "tiff", "tif", "ai", "eps",
    ];

    const ALLOWED_UPLOAD_MIME = [
        "image/jpeg", "image/jpg", "image/png", "image/svg+xml",
        "image/tiff", "application/pdf", "application/postscript",
        "application/illustrator", "application/vnd.adobe.illustrator",
    ];

    const NO_PREVIEW_EXT = ["ai", "eps"];

    const PRICE_VARIANTS = {
        shape: [
            { value: "Die-cut (WITH BORDER)", price: 0 },
            { value: "Rectangle", price: 0 },
            { value: "Rounded Rectangle", price: 0 },
            { value: "Circle", price: 0 },
            { value: "Square", price: 0 },
            { value: "Rounded Square", price: 0 },
            { value: "Die-cut (NO BACKGROUND)", price: 10 },
        ],
        size: {
            '8" Inches': 0,
            '10" Inches': 3,
            '12" Inches': 5,
            '20" Inches': 13,
            '30" Inches': 23,
            '40" Inches': 33,
            '50" Inches': 43,
        },
        lamination: [
            { value: "No", price: 0 },
            { value: "Yes, Add Lamination", price: 10 },
        ],
    };

    const CWD_PCS_CART_BTN_HTML = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.4 12.4a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L23 6H6"/></svg> Add to cart`;

    const CWD_PCS_CART_LOADING_HTML = `<span class="cwd-pcs-cart-loading"><svg class="cwd-pcs-cart-loading__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.22-8.56"/></svg>Adding to cart</span>`;

    function priceOf(groupKey, chosenValue) {
        if (!chosenValue) return 0;
        const list = PRICE_VARIANTS[groupKey] || [];
        const found = list.find((item) => item.value === chosenValue);
        return found ? found.price : 0;
    }

    function animatePriceChange(targetElement, start, end, duration = 500) {
        let startTime = null;
        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            const progress = Math.min((timestamp - startTime) / duration, 1);
            const currentValue = start + (end - start) * progress;
            targetElement.textContent = currentValue.toFixed(2);
            if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }

    function updateBuyBar(total) {
        const labelEl = document.getElementById("cwd-pcs-total-label");
        if (labelEl) labelEl.textContent = "TOTAL · WALL DECAL";

        const shippingWrap = document.getElementById("cwd-pcs-shipping");
        const fillEl = document.getElementById("cwd-pcs-shipping-fill");
        const textEl = document.getElementById("cwd-pcs-shipping-text");
        if (!shippingWrap || !fillEl) return;

        const toFree = FREE_SHIP_THRESHOLD - total;
        if (toFree <= 0) {
            shippingWrap.classList.add("is-free");
            if (textEl) {
                textEl.innerHTML = "You unlocked <strong>free shipping</strong>";
            }
            fillEl.style.width = "100%";
        } else {
            shippingWrap.classList.remove("is-free");
            if (textEl) {
                textEl.innerHTML = `Add <strong>$${toFree.toFixed(2)}</strong> more for <strong>free shipping</strong>`;
            }
            const pct = Math.min(
                100,
                Math.round(((FREE_SHIP_THRESHOLD - toFree) / FREE_SHIP_THRESHOLD) * 100)
            );
            fillEl.style.width = `${pct}%`;
        }
    }

    function getFileExtension(file) {
        const parts = file.name.split(".");
        return parts.length > 1 ? parts.pop().toLowerCase() : "";
    }

    function isAllowedUpload(file) {
        const ext = getFileExtension(file);
        if (ALLOWED_UPLOAD_EXT.includes(ext)) return true;
        if (file.type && ALLOWED_UPLOAD_MIME.includes(file.type)) return true;
        return false;
    }

    function readFileAsDataURL(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(new Error("Error reading file"));
            reader.readAsDataURL(file);
        });
    }

    let pdfJsLoading = null;
    function loadPdfJs() {
        if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
        if (pdfJsLoading) return pdfJsLoading;
        pdfJsLoading = new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
            script.onload = () => {
                window.pdfjsLib.GlobalWorkerOptions.workerSrc =
                    "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
                resolve(window.pdfjsLib);
            };
            script.onerror = () => reject(new Error("Could not load PDF preview library"));
            document.head.appendChild(script);
        });
        return pdfJsLoading;
    }

    async function renderPdfFirstPagePreview(file) {
        const pdfjsLib = await loadPdfJs();
        const data = await file.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({ data }).promise;
        const page = await pdf.getPage(1);
        const baseViewport = page.getViewport({ scale: 1 });
        const scale = Math.min(256 / baseViewport.width, 256 / baseViewport.height, 2);
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement("canvas");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({
            canvasContext: canvas.getContext("2d"),
            viewport,
        }).promise;
        return canvas.toDataURL("image/jpeg", 0.88);
    }

    async function buildUploadPreview(file) {
        const ext = getFileExtension(file);
        if (NO_PREVIEW_EXT.includes(ext)) {
            return { src: null, placeholder: true };
        }
        if (ext === "pdf" || file.type === "application/pdf") {
            try {
                const src = await renderPdfFirstPagePreview(file);
                return { src, placeholder: false };
            } catch (err) {
                console.warn("PDF preview failed:", err);
                return { src: null, placeholder: true };
            }
        }
        if (
            file.type.startsWith("image/") ||
            ["jpg", "jpeg", "png", "svg", "tiff", "tif"].includes(ext)
        ) {
            const src = await readFileAsDataURL(file);
            return { src, placeholder: false };
        }
        return { src: null, placeholder: true };
    }

    function setUploadPreview(src, usePlaceholder) {
        const thumb = document.getElementById("upload-preview-thumb");
        const placeholder = document.getElementById("upload-preview-placeholder");
        const hiddenPreview = document.getElementById("preview-image");
        if (!thumb) return;

        if (src && !usePlaceholder) {
            thumb.src = src;
            thumb.hidden = false;
            if (placeholder) placeholder.hidden = true;
            if (hiddenPreview) hiddenPreview.src = src;
        } else if (usePlaceholder) {
            thumb.removeAttribute("src");
            thumb.hidden = true;
            if (placeholder) placeholder.hidden = false;
            if (hiddenPreview) hiddenPreview.src = "";
        } else {
            thumb.removeAttribute("src");
            thumb.hidden = true;
            if (placeholder) placeholder.hidden = true;
            if (hiddenPreview) hiddenPreview.src = "";
        }
    }

    function formatUploadFileName(name, maxBaseLen = 22) {
        if (!name) return "";
        const lastDot = name.lastIndexOf(".");
        if (lastDot <= 0) {
            return name.length > maxBaseLen + 1
                ? `${name.slice(0, maxBaseLen)}…`
                : name;
        }
        const base = name.slice(0, lastDot);
        const ext = name.slice(lastDot);
        if (base.length <= maxBaseLen) return name;
        return `${base.slice(0, maxBaseLen)}…${ext}`;
    }

    function setUploadUI(hasFile, fileName) {
        const uploadZone = document.querySelector(".cwd-pcs-upload-zone");
        const successBar = document.getElementById("upload-success-bar");
        const filenameEl = document.getElementById("upload-filename");

        if (uploadZone) {
            uploadZone.classList.toggle("cwd-pcs-upload-zone--hidden", hasFile);
        }
        if (successBar) {
            successBar.classList.toggle("cwd-pcs-upload-success--visible", hasFile);
            if (hasFile) successBar.removeAttribute("hidden");
            else successBar.setAttribute("hidden", "");
        }
        if (filenameEl) {
            if (fileName) {
                filenameEl.textContent = formatUploadFileName(fileName);
                filenameEl.title = fileName;
            } else {
                filenameEl.textContent = "";
                filenameEl.removeAttribute("title");
            }
        }
        if (!hasFile) setUploadPreview(null, false);
    }

    function buildShapeOptionContent(shape) {
        const frag = document.createDocumentFragment();

        const name = document.createElement("span");
        name.className = "cwd-pcs-shape-name";
        name.textContent = shape.value;

        const badgeSlot = document.createElement("span");
        badgeSlot.className = "cwd-pcs-shape-badge-slot";
        if (shape.value === BEST_VALUE_SHAPE) {
            const badge = document.createElement("span");
            badge.className = "cwd-pcs-badge cwd-pcs-badge--gold";
            badge.textContent = "Best Value ★";
            badgeSlot.appendChild(badge);
        } else {
            badgeSlot.setAttribute("aria-hidden", "true");
        }

        const price = document.createElement("span");
        price.className = "cwd-pcs-shape-price";
        price.textContent =
            shape.price > 0 ? `+ $${shape.price}` : "Included";

        frag.appendChild(name);
        frag.appendChild(badgeSlot);
        frag.appendChild(price);
        return frag;
    }

    function getShapeDisplayText(shape) {
        return shape.price > 0
            ? `${shape.value} + $${shape.price}`
            : shape.value;
    }

    function populateShapeOptions() {
        const dd = document.getElementById("shape-select");
        const listUL = dd.querySelector(".dropdown-options");
        listUL.innerHTML = "";

        PRICE_VARIANTS.shape.forEach((shape) => {
            const li = document.createElement("li");
            li.dataset.value = shape.value;
            li.appendChild(buildShapeOptionContent(shape));
            listUL.appendChild(li);
        });

        const firstLi = listUL.querySelector("li");
        if (firstLi) {
            listUL.querySelectorAll("li").forEach((li) => li.classList.remove("selected"));
            firstLi.classList.add("selected");
            const firstShape = PRICE_VARIANTS.shape[0];
            dd.querySelector(".selected-text").textContent = getShapeDisplayText(firstShape);
            dd.classList.add("variant-picked");
            state.shape = firstLi.dataset.value;
        }
    }

    function buildSizeRow(sizeLabel, priceExtra, isActive) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = `sticker-variant${isActive ? " active" : ""}`;
        btn.dataset.size = sizeLabel;
        btn.dataset.value = priceExtra;

        const radio = document.createElement("span");
        radio.className = "cwd-pcs-radio";
        radio.setAttribute("aria-hidden", "true");

        const label = document.createElement("span");
        label.className = "cwd-pcs-size-label";
        label.textContent = sizeLabel;

        const badgeSlot = document.createElement("span");
        badgeSlot.className = "cwd-pcs-size-badge-slot";
        if (sizeLabel === MOST_POPULAR_SIZE) {
            const badge = document.createElement("span");
            badge.className = "cwd-pcs-badge cwd-pcs-badge--blue";
            badge.textContent = "Most Popular";
            badgeSlot.appendChild(badge);
        } else {
            badgeSlot.setAttribute("aria-hidden", "true");
        }

        const extra = document.createElement("span");
        extra.className = "cwd-pcs-size-extra";
        extra.textContent =
            priceExtra > 0 ? `+ $${priceExtra.toFixed(2)}` : "Base price";

        const total = document.createElement("span");
        total.className = "cwd-pcs-size-total";
        total.textContent = `$${(9.99 + priceExtra).toFixed(2)}`;

        const prices = document.createElement("span");
        prices.className = "cwd-pcs-size-prices";
        prices.appendChild(extra);
        prices.appendChild(total);

        btn.appendChild(radio);
        btn.appendChild(label);
        btn.appendChild(badgeSlot);
        btn.appendChild(prices);
        return btn;
    }

    function populateSizeOptions() {
        const list = document.getElementById("size-selection");
        const labelEl = document.getElementById("size-shape-label");
        if (!list) return;

        list.innerHTML = "";
        const sizes = Object.keys(PRICE_VARIANTS.size);

        sizes.forEach((sizeLabel) => {
            const priceExtra = PRICE_VARIANTS.size[sizeLabel] || 0;
            const isActive = sizeLabel === MOST_POPULAR_SIZE;
            list.appendChild(buildSizeRow(sizeLabel, priceExtra, isActive));
        });

        if (labelEl) labelEl.textContent = "(Longest Side)";

        state.size = MOST_POPULAR_SIZE;

        recalcPrice();
    }

    function dropdownClickHandler(evt) {
        const dropdown = evt.target.closest(".select-dropdown");
        if (!dropdown) {
            document.querySelectorAll(".dropdown-options").forEach(
                (list) => (list.style.display = "none")
            );
            document.querySelectorAll(".select-dropdown").forEach((dd) => {
                dd.classList.remove("is-open");
            });
            return;
        }

        const list = dropdown.querySelector(".dropdown-options");
        const header = dropdown.querySelector(".selected-text");
        const stateKey = dropdown.dataset.stateKey || dropdown.id.replace(/-select$/, "");
        const optionEl = evt.target.closest("li[data-value]");

        document.querySelectorAll(".dropdown-options").forEach((other) => {
            if (other !== list) {
                other.style.display = "none";
                other.closest(".select-dropdown")?.classList.remove("is-open");
            }
        });

        if (optionEl) {
            const value = optionEl.dataset.value;
            list.querySelectorAll("li").forEach((li) => li.classList.remove("selected"));
            optionEl.classList.add("selected");

            const shapeObj = PRICE_VARIANTS.shape.find((s) => s.value === value);
            header.textContent = shapeObj
                ? getShapeDisplayText(shapeObj)
                : optionEl.querySelector(".cwd-pcs-shape-name")?.textContent.trim() || "";
            dropdown.classList.add("variant-picked");

            if (stateKey) state[stateKey] = value;

            const variantBox = dropdown.closest(".pcs-variant, .cwd-pcs-variant");
            if (variantBox) {
                variantBox.classList.remove("has-error");
                const errorBar = variantBox.querySelector(".error-bar");
                if (errorBar) errorBar.style.display = "none";
            }

            if (stateKey === "shape") {
                populateSizeOptions();
            }

            list.style.display = "none";
            dropdown.classList.remove("is-open");
            recalcPrice();
            return;
        }

        const opening = list.style.display !== "block";
        list.style.display = opening ? "block" : "none";
        dropdown.classList.toggle("is-open", opening);
    }

    function setupSizeSelection() {
        const wrapper = document.getElementById("size-selection");
        if (!wrapper) return;

        wrapper.addEventListener("click", (event) => {
            const selected = event.target.closest(".sticker-variant");
            if (!selected) return;
            event.preventDefault();

            wrapper.querySelectorAll(".sticker-variant").forEach((el) => {
                el.classList.toggle("active", el === selected);
            });

            state.size = selected.dataset.size;

            const variantBox = document.getElementById("size-variant");
            if (variantBox) {
                variantBox.classList.remove("has-error");
                const errorBar = document.getElementById("size-error-bar");
                if (errorBar) errorBar.style.display = "none";
            }

            recalcPrice();
        });
    }

    function handleSpecialInstructionsInput() {
        const input = document.getElementById("special-instructions-input");
        const counter = document.getElementById("special-instructions-char-count");
        const MAX = 1000;

        const refresh = () => {
            if (input.value.length > MAX) {
                input.value = input.value.slice(0, MAX);
            }
            state.Notes = input.value;
            const remaining = MAX - input.value.length;
            counter.textContent = `${remaining} character(s) left`;
        };

        refresh();
        input.addEventListener("input", refresh);
    }

    function setupLaminationSelection() {
        const lamWrapper = document.getElementById("lamination-selection");
        if (!lamWrapper) return;

        lamWrapper.addEventListener("click", (event) => {
            const selected = event.target.closest(".sticker-variant");
            if (!selected) return;
            event.preventDefault();

            lamWrapper.querySelectorAll(".sticker-variant").forEach((el) => {
                el.classList.toggle("active", el === selected);
            });

            state.Lamination = selected.dataset.lamination;
            recalcPrice();
        });
    }

    function recalcPrice() {
        let total = 9.99;

        total += PRICE_VARIANTS.shape.find((s) => s.value === state.shape)?.price || 0;
        total += PRICE_VARIANTS.size[state.size] || 0;
        total += priceOf("lamination", state.Lamination);

        const ticker = document.getElementById("pcs-final-price");
        const prevValue = parseFloat(ticker.textContent) || 0;
        if (prevValue !== total) {
            animatePriceChange(ticker, prevValue, total);
        }
        state.price = total;
        updateBuyBar(total);
    }

    function setupImageUpload() {
        const fileInput = document.getElementById("upload-file");
        const chooseFileBtn = document.getElementById("choose-file-btn");
        const deleteImage = document.getElementById("delete-image");
        const errorMessage = document.getElementById("upload-file-error");
        const dropZone = document.querySelector(".cwd-pcs-upload-zone");

        const freshChooseBtn = chooseFileBtn.cloneNode(true);
        const freshFileInput = fileInput.cloneNode(true);
        chooseFileBtn.replaceWith(freshChooseBtn);
        fileInput.replaceWith(freshFileInput);

        freshChooseBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            freshFileInput.click();
        });

        if (dropZone) {
            ["dragenter", "dragover"].forEach((evt) => {
                dropZone.addEventListener(evt, (e) => {
                    e.preventDefault();
                    dropZone.classList.add("is-dragover");
                });
            });
            ["dragleave", "drop"].forEach((evt) => {
                dropZone.addEventListener(evt, (e) => {
                    e.preventDefault();
                    dropZone.classList.remove("is-dragover");
                });
            });
            dropZone.addEventListener("drop", (e) => {
                const file = e.dataTransfer?.files?.[0];
                if (!file) return;
                const dt = new DataTransfer();
                dt.items.add(file);
                freshFileInput.files = dt.files;
                freshFileInput.dispatchEvent(new Event("change", { bubbles: true }));
            });
        }

        freshFileInput.addEventListener("change", async function (event) {
            const file = event.target.files[0];
            if (!file) return;

            if (!isAllowedUpload(file)) {
                errorMessage.textContent =
                    "Please upload a valid file (.jpg, .png, .pdf, .svg, .ai, .eps)";
                errorMessage.style.display = "block";
                state.uploadedImage = null;
                setUploadPreview(null, false);
                return;
            }

            try {
                const preview = await buildUploadPreview(file);
                setUploadPreview(preview.src, preview.placeholder);
                setUploadUI(true, file.name);
                errorMessage.style.display = "none";
                errorMessage.classList.remove("active");
                state.uploadedImage = file;
            } catch (err) {
                console.error(err);
                errorMessage.textContent = "Error reading file";
                errorMessage.style.display = "block";
                state.uploadedImage = null;
                setUploadPreview(null, false);
            }
        });

        deleteImage.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            freshFileInput.value = "";
            setUploadUI(false);
            state.uploadedImage = null;
        });
    }

    function validateForm() {
        let firstInvalid = null;

        const uploadOK =
            state.uploadedImage && typeof state.uploadedImage.name !== "undefined";
        const uploadErr = document.getElementById("upload-file-error");
        if (uploadErr) {
            uploadErr.textContent = uploadOK ? "" : "Please upload an image.";
            uploadErr.classList.toggle("active", !uploadOK);
            uploadErr.style.display = uploadOK ? "none" : "block";
            if (!uploadOK && !firstInvalid) {
                firstInvalid = document.getElementById("artwork-variant");
            }
        }
        if (!uploadOK) {
            document.getElementById("artwork-variant")?.classList.add("has-error");
        } else {
            document.getElementById("artwork-variant")?.classList.remove("has-error");
        }

        const toggleVariant = (isValid, boxId, barId) => {
            const box = document.getElementById(boxId);
            const bar = document.getElementById(barId);
            if (!box || !bar) return;
            box.classList.toggle("has-error", !isValid);
            bar.style.display = isValid ? "none" : "block";
            if (!isValid && !firstInvalid) firstInvalid = box;
        };

        toggleVariant(!!state.shape, "shape-variant", "shape-error-bar");
        toggleVariant(!!state.size, "size-variant", "size-error-bar");

        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
            return false;
        }
        return true;
    }

    function resetCalculatorForm() {
        const fileInput = document.getElementById("upload-file");
        if (fileInput) fileInput.value = "";

        setUploadUI(false);

        const previewImg = document.getElementById("preview-image");
        if (previewImg) previewImg.src = "";
        setUploadPreview(null, false);

        const uploadErr = document.getElementById("upload-file-error");
        if (uploadErr) {
            uploadErr.textContent = "";
            uploadErr.classList.remove("active");
            uploadErr.style.display = "none";
        }

        ["shape-error-bar", "size-error-bar"].forEach((id) => {
            const bar = document.getElementById(id);
            if (bar) bar.style.display = "none";
        });
        document
            .querySelectorAll(".cwd-pcs-variant.has-error, .pcs-variant.has-error")
            .forEach((v) => v.classList.remove("has-error"));

        const shapeDD = document.getElementById("shape-select");
        if (shapeDD) {
            shapeDD.classList.add("variant-picked");
            const defaultShape = PRICE_VARIANTS.shape[0];
            shapeDD.querySelector(".selected-text").textContent =
                getShapeDisplayText(defaultShape);
            shapeDD.querySelectorAll("li").forEach((li) => {
                li.classList.toggle(
                    "selected",
                    li.dataset.value === "Die-cut (WITH BORDER)"
                );
            });
        }
        state.shape = "Die-cut (WITH BORDER)";

        const specialInstructionsInput = document.getElementById("special-instructions-input");
        if (specialInstructionsInput) {
            specialInstructionsInput.value = "";
            document.getElementById("special-instructions-char-count").textContent =
                "1000 character(s) left";
            state.Notes = "";
        }

        const laminationWrapper = document.getElementById("lamination-selection");
        if (laminationWrapper) {
            laminationWrapper.querySelectorAll(".sticker-variant").forEach((el) => {
                el.classList.remove("active");
            });
            const firstOption = laminationWrapper.querySelector(".sticker-variant");
            if (firstOption) {
                firstOption.classList.add("active");
                state.Lamination = firstOption.dataset.lamination;
            }
        }

        populateSizeOptions();
        state.uploadedImage = null;
        recalcPrice();
    }

    function setupApippaAddToCart() {
        const addToCartBtn = document.getElementById("pcs-add-to-cart");
        if (!addToCartBtn) return;
        if (addToCartBtn.dataset.bound) return;
        addToCartBtn.dataset.bound = "true";

        addToCartBtn.addEventListener("click", async (e) => {
            e.preventDefault();

            if (!validateForm()) {
                console.log("Form invalid – fix the highlighted fields.");
                return;
            }

            addToCartBtn.classList.remove("shine");
            addToCartBtn.disabled = true;
            addToCartBtn.classList.add("loading");
            addToCartBtn.innerHTML = CWD_PCS_CART_LOADING_HTML;

            try {
                const requestData = {
                    calculatorId: "d374a79a634b4",
                    productId: 7705248890928,
                    properties: {
                        "Upload Image": state.uploadedImage?.name,
                        Shape: state.shape,
                        Size: state.size,
                        Lamination: state.Lamination,
                        Notes: state.Notes,
                        Price: state.price.toFixed(2),
                    },
                };

                const variantRes = await fetch(
                    "https://api.custompricecalculator.com/api/v1/variant",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(requestData),
                    }
                );
                const variantJson = await variantRes.json();
                const shopifyVariantId =
                    typeof variantJson === "string"
                        ? variantJson
                        : variantJson?.variantId || variantJson?.id;
                if (!shopifyVariantId) throw new Error("Invalid variant ID");

                const formData = new FormData();
                formData.append("id", shopifyVariantId);
                formData.append("quantity", 1);
                if (state.uploadedImage) {
                    formData.append("properties[Upload Image]", state.uploadedImage);
                }
                Object.entries(requestData.properties).forEach(([k, v]) => {
                    if (k !== "Upload Image") formData.append(`properties[${k}]`, v);
                });

                const cartAddRes = await fetch("/cart/add.js", {
                    method: "POST",
                    body: formData,
                });
                const cartAddJson = await cartAddRes.json();
                if (!cartAddRes.ok) throw new Error("Failed to add to cart");

                const cartJson = {
                    items: [cartAddJson],
                    item_count: 1,
                    total_price: cartAddJson.final_price,
                    original_total_price: cartAddJson.original_price,
                    total_discount: 0,
                };

                const miniCartHTML = await fetch(
                    `/cart?section_id=mini-cart&t=${Date.now()}`
                )
                    .then((r) => r.text())
                    .then((html) => {
                        const d = document.createElement("div");
                        d.innerHTML = html;
                        return d.querySelector("cart-drawer")?.outerHTML;
                    });

                const cartDrawer = document.querySelector("cart-drawer");
                if (cartDrawer && miniCartHTML) {
                    cartDrawer.dispatchEvent(
                        new CustomEvent("cart:refresh", {
                            bubbles: true,
                            detail: {
                                cart: { ...cartJson, sections: { "mini-cart": miniCartHTML } },
                                openMiniCart: true,
                            },
                        })
                    );
                }

                setTimeout(() => {
                    cartDrawer?.querySelectorAll("line-item").forEach((li) => {
                        const priceNode =
                            li.querySelector(".line-item__price-list-container .price") ||
                            li.querySelector(".product-item-meta__price-list-container .price");
                        if (!priceNode) return;
                        if (!/Free|\$0\.00/.test(priceNode.textContent.trim())) return;

                        const vid =
                            li
                                .querySelector("a[href*='?variant=']")
                                ?.href.split("variant=")[1]
                                ?.split("&")[0] ||
                            li
                                .querySelector("a[href*='/cart/change?id=']")
                                ?.href.match(/id=(\d+):/)?.[1];
                        if (vid && String(vid) === String(shopifyVariantId)) {
                            const correct = (cartAddJson.price / 100).toFixed(2);
                            priceNode.innerHTML = `<span class="visually-hidden">Sale price</span>$${correct}`;
                        }
                    });
                }, 300);

                setTimeout(async () => {
                    const count = (await fetch("/cart.js").then((r) => r.json())).item_count;
                    const countEl = document.querySelector("cart-count");
                    if (countEl) countEl.textContent = count;
                }, 300);

                setTimeout(async () => {
                    const drawerContent = document.querySelector(
                        "#shopify-section-mini-cart .drawer__content"
                    );
                    if (!drawerContent) return;

                    if (!customElements.get("dotlottie-player")) {
                        await new Promise((res) => {
                            const s = document.createElement("script");
                            s.src =
                                "https://unpkg.com/@dotlottie/player-component@latest/dist/dotlottie-player.js";
                            s.onload = res;
                            document.head.appendChild(s);
                        });
                    }

                    const confetti = document.createElement("dotlottie-player");
                    confetti.className = "mini-cart-lottie";
                    confetti.setAttribute(
                        "src",
                        "//cdn.shopify.com/s/files/1/0582/5400/0176/files/confetti.json?v=1748024242"
                    );
                    confetti.setAttribute("background", "transparent");
                    confetti.setAttribute("speed", "1");
                    confetti.setAttribute("style", "width: 300px; height: 300px");
                    confetti.setAttribute("direction", "1");
                    confetti.setAttribute("playmode", "normal");
                    confetti.setAttribute("autoplay", "");
                    drawerContent.prepend(confetti);
                    setTimeout(() => confetti.remove(), 3000);
                }, 1000);
            } catch (err) {
                console.error("Apippa Add-to-Cart Error:", err);
                alert("There was a problem adding your item to the cart.");
            } finally {
                addToCartBtn.disabled = false;
                addToCartBtn.classList.remove("loading");
                addToCartBtn.innerHTML = CWD_PCS_CART_BTN_HTML;
                resetCalculatorForm();
                recalcPrice();
            }
        });
    }

    function playCartButtonShine() {
        const btn = document.getElementById("pcs-add-to-cart");
        if (!btn || btn.classList.contains("loading")) return;
        btn.classList.remove("shine");
        void btn.offsetWidth;
        btn.classList.add("shine");
    }

    function setupCartButtonShine() {
        const btn = document.getElementById("pcs-add-to-cart");
        if (!btn || btn.dataset.shineBound) return;
        btn.dataset.shineBound = "true";
        setTimeout(playCartButtonShine, 1500);
        setInterval(playCartButtonShine, 5000);
    }

    function initialize() {
        setupImageUpload();
        setupSizeSelection();
        setupLaminationSelection();
        handleSpecialInstructionsInput();
        setupApippaAddToCart();
        setupCartButtonShine();
        document.addEventListener("click", dropdownClickHandler);
        populateShapeOptions();
        populateSizeOptions();
        recalcPrice();
    }

    initialize();
});
